







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import keyring from '@polkadot/ui-keyring';
import Keypair from '../shared/accounts/Keypair.vue';
import { u8aToHex } from '@polkadot/util';
import Connector from '@vue-polkadot/vue-api';

@Component({
  components: {
    Keypair,
  },
})
export default class Accounts extends Vue {
  private chainProperties: any;
  public searchFilter: string = ''.toLowerCase();
  public theme: string = 'substrate';
  public modal: object = {
    create: false, import: false, backup: false, changePass: false };
  public keyringAccounts: any = [
    { address: '', meta: { name: ''}, publicKey: '', type: '' },
  ];
  public keyringAccountsFilter: any = [
    { address: '', meta: { name: ''}, publicKey: '', type: '' },
  ];

  public vueU8aToHex(publicKey: Uint8Array): string {
    return u8aToHex(publicKey);
  }

  public filterByName(searchFilter: string): void {
    for (const acc of this.keyringAccounts) {
      if (searchFilter.length === 0) {
        acc.visible = true;
      }
      
      if (acc.meta.name.toLowerCase().includes(searchFilter)
        || acc.meta.tags && acc.meta.tags.reduce((result: boolean, tag: string): boolean => {
          return result || tag.toLowerCase().includes(searchFilter); }) ) {
        acc.visible = true;
      } else {
        acc.visible = false;
      }
    }
  }

  

  @Watch('$store.state.keyringLoaded')
  public mapAccounts(): void {
    if (this.isKeyringLoaded()) {
      this.keyringAccounts = keyring.getPairs();
      // this.keyringAccountsFilter = keyring.getPairs();
    }
  }

  public isKeyringLoaded() {
    return this.$store.state.keyringLoaded;
  }

  public getIconTheme() {
    this.theme = this.$store.state.setting.icon;
  }

  public async mounted(): Promise<void> {
    this.isKeyringLoaded();
    this.mapAccounts();
    this.getIconTheme();
    this.filterByName(this.searchFilter);
  }
}
